
import { FirearmStorageLocationPLIEntityDecorator } from './firearm-storage-location-pli.decorator';
import { FirearmStorageLocationPLI } from './firearm-storage-location-pli.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class FirearmStorageLocationPLITypeInfoBase implements CrudTypeInfo<FirearmStorageLocationPLI, number> {
  name = 'Firearm Storage Location PLI';
  entityDecorator = new FirearmStorageLocationPLIEntityDecorator();
  
  createAuthorities = ['WRITE_FIREARM_STORAGE_LOCATION_PLI'];
  editAuthorities = ['WRITE_FIREARM_STORAGE_LOCATION_PLI'];
  deleteAuthorities = ['WRITE_FIREARM_STORAGE_LOCATION_PLI'];
  viewAuthorities = ['READ_FIREARM_STORAGE_LOCATION_PLI'];
  
  searchRouteBase = ['/firearmstoragelocationpli/search'];
  createRouteBase = ['/firearmstoragelocationpli/create'];
  editRouteBase = ['/firearmstoragelocationpli/edit'];
  viewRouteBase = ['/firearmstoragelocationpli/view'];
  
  description(item: FirearmStorageLocationPLI): string {
    return '' +  item.firearmStorageLocationPLIId;
  }
}



